import { render, staticRenderFns } from "./LeaveWasRejected.vue?vue&type=template&id=b8df6670"
import script from "./LeaveWasRejected.vue?vue&type=script&lang=js"
export * from "./LeaveWasRejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports